import { render } from "./WebcamComponent.vue?vue&type=template&id=ac371c18&scoped=true"
import script from "./WebcamComponent.vue?vue&type=script&lang=js"
export * from "./WebcamComponent.vue?vue&type=script&lang=js"

import "./WebcamComponent.vue?vue&type=style&index=0&id=ac371c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac371c18"]])

export default __exports__